export const SEARCH_FIELDS = [
  '资源名称', '一句话价值', '主赛道', '资源类型', '标签',
  '适用对象', '前置条件', '保存方式', '资源正文'
] as const;

export const DETAIL_FIELDS = [
  ...SEARCH_FIELDS, '原始链接', '来源日期', '最后检查日期'
] as const;

export type ResourceField = typeof DETAIL_FIELDS[number];

export type Resource = {
  id: string;
  fields: Record<string, string>;
};

export type FieldMeta = { id: string; name: string };

export function cellToText(value: unknown): string {
  if (value == null) return '';
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return String(value);
  if (Array.isArray(value)) return value.map(cellToText).filter(Boolean).join('、');
  if (typeof value === 'object') {
    const item = value as Record<string, unknown>;
    for (const key of ['text', 'name', 'value', 'title', 'url']) {
      if (item[key] != null) return cellToText(item[key]);
    }
    return Object.values(item).map(cellToText).filter(Boolean).join('、');
  }
  return '';
}

export function cellToUrl(value: unknown): string {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) {
    for (const item of value) {
      const url = cellToUrl(item);
      if (url) return url;
    }
    return '';
  }
  if (typeof value === 'object') {
    const item = value as Record<string, unknown>;
    for (const key of ['link', 'url']) {
      if (typeof item[key] === 'string' && item[key]) return item[key];
    }
  }
  return '';
}

function dateToText(value: unknown): string {
  if (typeof value !== 'number' || !Number.isFinite(value)) return cellToText(value);
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(date);
}

export function normalizeFields(raw: { id?: string; recordId?: string; record_id?: string; fields?: Record<string, unknown> }, metas: FieldMeta[]): Resource {
  const byId = new Map(metas.map((meta) => [meta.id, meta.name]));
  const fields: Record<string, string> = {};
  for (const [id, value] of Object.entries(raw.fields ?? {})) {
    const name = byId.get(id) ?? id;
    fields[name] = name === '原始链接'
      ? cellToUrl(value)
      : name === '来源日期' || name === '最后检查日期'
        ? dateToText(value)
        : cellToText(value);
  }
  return { id: raw.recordId ?? raw.id ?? raw.record_id ?? '', fields };
}

export function getFieldId(metas: FieldMeta[], name: string): string | undefined {
  return metas.find((meta) => meta.name === name)?.id;
}
